<template>
  <!-- 对话框 -->
  <el-dialog title="bug审核" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box" style="max-height: 70vh; overflow-y: auto;">
      <el-form label-width="80px">


        <div style="display: flex; justify-content: space-around;" v-if="determine_data!=null">

          <el-image :preview-src-list="srcList" v-if="img_url.img_one" :src="img_url.img_one" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>







          <el-image :preview-src-list="srcList" v-if="img_url.img_two" :src="img_url.img_two" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>







          <el-image :preview-src-list="srcList" v-if="img_url.img_three" :src="img_url.img_three" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>




        </div>

        <div v-if="determine_data!=null">

          <el-form-item label="描述:" label-width='120px'>

            {{determine_data.description}}

          </el-form-item>

        </div>


        <el-form-item label="审核判定:" label-width='120px' v-if="determine_data!=null">



          <el-radio-group v-model="submit_data.status">

            <el-radio-button :label="item.val" v-for="(item, index) in status_array" :key="index"
              v-if="submit_data.status.val != 0 && index != 0">
              {{item.alias}}
            </el-radio-button>

          </el-radio-group>

        </el-form-item>




        <el-form-item label="备注:" label-width='120px' v-if="determine_data!=null">
          <el-input type="textarea" autosize v-model="submit_data.remarks"
            :placeholder="submit_rules.remarks.placeholder">
          </el-input>
        </el-form-item>

        <div v-if="determine_data == null" style="text-align: center;margin-bottom: 20px;">该司机无审核信息,不能进行审核</div>

      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="determineonSubmit" v-if="submit_btn_show">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.bug_code = _this.data;


        this.$post(
            "/bug/getBugDetails", {
              bug_code: this.data
            }
          )
          .then(res => {

            // 判断返回的data中是否有值
            if (res.data == null) {

              this.determine_data = null;

            } else {


              this.determine_data = {};
              // 返回的data中的值赋给submit_data对象,并在returnData中做标记
              this.determine_data.description = res.data.description;


              this.submit_data.status = res.data.status.val;
              this.status_array = res.data.status.select_array;
              this.submit_data.remarks = res.data.remarks;

              // 图片路径
              this.img_url.img_one = res.data.img_one.url;
              this.img_url.img_two = res.data.img_two.url;
              this.img_url.img_three = res.data.img_three.url;

              this.srcList.length = 0;
              this.srcList.push(this.img_url.img_one)
              this.srcList.push(this.img_url.img_two)
              this.srcList.push(this.img_url.img_three)

              // 如果状态为已处理，隐藏保存按钮
              if (_this.submit_data.status == '2') {

                _this.submit_btn_show = false;

              } else {

                _this.submit_btn_show = true;

              }

            }


          })



      },

    },
    data() {
      return {

        show: false,
        srcList: [],

        status_array: [],

        submit_btn_show: true,

        //上传图片
        img_url: {
          img_one: '',
          img_two: '',
          img_three: ''
        },

        determine_data: {},

        // 表单数据
        submit_data: {
          bug_code: '',
          status: '',
          remarks: ''
        },

        submit_rules: {
          status: {
            placeholder: '审核判定',
            rules: {
              required: true,
              message: '未选择审核判定状态',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          remarks: {
            placeholder: '请输入备注',
            rules: {
              required: false,
              message: '备注需小于200字',
              regulation: 'lt_str',
              rulesData: 200
            }
          },

        },

      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },

      // 提交按钮
      determineonSubmit() {

        _this.$post(
            '/bug/executeBugSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success(res.msg)
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();

          }).catch((err) => {

          })

      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;

  }

  .el-form-item__content {
    position: relative;
  }
</style>